import { render } from "./RightMenu.vue?vue&type=template&id=631e4dd0&scoped=true"
import script from "./RightMenu.vue?vue&type=script&lang=js"
export * from "./RightMenu.vue?vue&type=script&lang=js"

import "./RightMenu.vue?vue&type=style&index=0&id=631e4dd0&lang=scss&scoped=true"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631e4dd0"]])

export default __exports__